/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Benefits_BadgeInputs */

const et_benefits_badge = /** @type {(inputs: Benefits_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Miks?`)
};

const en_benefits_badge = /** @type {(inputs: Benefits_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benefits`)
};

/**
* | output |
* | --- |
* | "Benefits" |
*
* @param {Benefits_BadgeInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const benefits_badge = /** @type {((inputs?: Benefits_BadgeInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Benefits_BadgeInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_benefits_badge(inputs)
	return en_benefits_badge(inputs)
});